import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/** 通用路由表 */
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/index/index'),
    hidden: true
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap,
})



// WEBPACK FOOTER //
// ./src/router/index.js